<template>
  <ImageHeader :headerTitle="'Über diese Web-App'" :imageSource="require('../assets/leeb-images3/pic1.jpg')">
    <v-card elevation="0">
      <v-card-text>
        <p class="pb-2">Diese Web-Applikation wird entwickelt und betreut von:</p>
        <p class="pb-2">
          <b>LEEB Balkone GmbH</b><br>
          Maitratten 25<br>
          9563 Gnesau<br>
          Österreich<br>
        </p>
        <p class="pb-2">Zuständig:</p>
        <p class="pb-2">
          <b>Joel Strasser</b><br>
          Abteilung: IT<br>
          +43 4278 700 108<br>
          j.strasser@leeb-balkone.com<br>
        </p>
        <p class="pb-2">Mit Unterstützung durch:</p>
        <p class="pb-2">
          <ul>
            <li>Vue.js</li>
            <li>Vuetify</li>
            <li>Material Design</li>
            <li>Material Design Icons</li>
            <li>Axios</li>
          </ul>
        </p>
        <p>Version der Web-Applikation: <b>{{ version }}</b> ({{ gitHash }})</p>
      </v-card-text>
    </v-card>
  </ImageHeader>
</template>

<script>
import ImageHeader from '../components/ImageHeader.vue'

export default {
  name: 'About',
  components: {
    ImageHeader
  },
  data() {
    return {
      version: process.env.VUE_APP_CSPRTL_VERSION,
      gitHash: process.env.VUE_APP_CSPRTL_GITDESC
    }
  }
}
</script>
